var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTracker = function SvgTracker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 2,
    clipPath: "url(#tracker_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.05 16.202-4.829-2.414 4.83-2.415a1.6 1.6 0 0 0 .716-.716l2.414-4.83 2.415 4.83a1.6 1.6 0 0 0 .716.716l4.83 2.415-4.83 2.414a1.6 1.6 0 0 0-.716.716l-2.415 4.83-2.414-4.83a1.6 1.6 0 0 0-.716-.716ZM17.53 5.83l-1.49-.745 1.49-.746a1.4 1.4 0 0 0 .627-.626l.745-1.49.745 1.49c.136.271.355.491.626.626l1.49.746-1.49.745.448.894-.448-.894a1.4 1.4 0 0 0-.626.626l-.745 1.49-.745-1.49a1.4 1.4 0 0 0-.626-.626Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tracker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTracker;